import React from "react";
import LinearProgress from "@material-ui/core/LinearProgress";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import TitlePage from "../../app/Title/TitlePage/TitlePageView";
import {Button} from "primereact/button";
import SubtitleLabel from "../../app/Title/SubtitleLabel/SubtitleLabelView";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";

const CustodiaBanamexView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.messagesGrowl}
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <TitlePage title='Mantenimientos / Custodia Banamex'/>
                    </Grid>
                    <Grid item xs={6} style={{textAlign: "right"}}>
                        <Button label="Guardar" onClick={props.openConfMsgSave} disabled={props.isDisabledData}/> &nbsp;&nbsp;
                        <Button label="Desbloquear" onClick={props.openConfMsgEnabled} className="p-button-secondary"/>
                    </Grid>
                    <Grid item xs={12}>
                        <div className="p-grid">
                            <div className="p-col-6">
                                <SubtitleLabel header="Usuario" isBold={true}/>
                                <InputText name="username" placeholder="Ex: Usuario 1"
                                           keyfilter={/^[0-9 A-Z a-z]*$/}
                                           maxLength={20}
                                           onChange={props.onChangeData}
                                           value={props.username} tabIndex={1}
                                           disabled={props.isDisabledData}
                                />
                            </div>
                            <div className="p-col-6" style={{textAlign: "right"}}>
                                <Button label="Restaurar Datos" onClick={props.restartData} className="p-button-secondary"
                                        disabled={props.isDisabledData}/>
                            </div>
                            <div className="p-col-6">
                                <SubtitleLabel header="Contraseña" isBold={true}/>
                                <InputText name="password" placeholder="Ex: contra1"
                                           maxLength={20}
                                           onChange={props.onChangeData}
                                           value={props.password} tabIndex={2}
                                           disabled={props.isDisabledData}
                                />
                            </div><div className="p-col-6"/>
                            <div className="p-col-6">
                                <SubtitleLabel header="Dominio" isBold={true}/>
                                <Dropdown name="domainObj"
                                          options={props.domains}
                                          filterBy="domain"
                                          optionLabel="domain"
                                          onChange={props.onChangeData}
                                          value={props.domainObj}
                                          disabled={props.isDisabledData}/>
                            </div><div className="p-col-6"/>
                            {props.confMsgEnabled}
                            {props.confMsgSave}
                        </div>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default (CustodiaBanamexView);